import axios from "axios";
import store from "../store";
import { service, actions } from "../auth/redux";
import swal from "sweetalert";

export const authttp = axios.create({
    baseURL: `${process.env.REACT_APP_API_ENDPOINT_URL}${process.env.REACT_APP_API_VERSION}`
});

export const zero = axios.create({
    baseURL: `${process.env.REACT_APP_API_ENDPOINT_URL}${process.env.REACT_APP_API_VERSION}`,
    withCredentials: true
});

zero.interceptors.request.use(config => {
    if (config.url !== '/auth/login-token/') {
        const token = localStorage.getItem('_tk_');
        if (token) {
            config.data = { ...config.data, token };
        }
    }
    return config;
});

authttp.interceptors.request.use(config => {
    if (config.url === "/auth/refresh-token/") {
        const token = localStorage.getItem("_tk_");
        if (token) {
            config.data = { ...config.data, token };
        }
    }
    return config;
});

export const http = axios.create({
    baseURL: `${process.env.REACT_APP_API_ENDPOINT_URL}${process.env.REACT_APP_API_VERSION}`
});

http.interceptors.request.use(config => {
    const token = localStorage.getItem("_tk_");
    if (token) {
        config.headers.Authorization = `JWT ${token}`;
    }
    return config;
});

http.interceptors.response.use(
    response => response,
    err => {
        if (err.response) {
            switch (err.response.status) {
                case 401: {
                    return on401(err);
                }
                case 403: {
                    const { detail } = err.response.data;
                    if (detail) {
                        swal({
                            title: "Warning",
                            text: detail,
                            icon: "warning",
                            button: false
                        });
                    }
                    return Promise.reject(err);
                }
                default: {
                    throw err;
                }
            }
        } else {
            swal({
                title: "Warning",
                text: "We have detected a problem in your connection",
                icon: "warning"
            });

            // store.dispatch(auth.actions.logOut());
        }
    }
);

const on401 = err => {
    return service
        .tokenRefresh()
        .then(response => {
            const { token, refresh_token } = response.data;
            localStorage.setItem("_tk_", token);
            localStorage.setItem("_rf_", refresh_token);
            err.response.config.headers.Authorization = `JWT ${token}`;
            return http.request(err.response.config);
        })
        .catch(() => {
            store.dispatch(actions.logOut());
        });
};
